import axios from 'axios'
import React, { useEffect, useState } from 'react'

export default function AdminHome() {
  const [contact, setContact] = useState([])
  const [count, SetCount] = useState([])
  useEffect(() => {
    const Count = async () => {
      const res = await axios.get("http://localhost:8080/counts")
      SetCount(res.data)
    }
    Count()
    const Contact = async () => {
      const res = await axios.get("http://localhost:8080/feedbacks")
      setContact(res.data)
    }
    Contact()
  }, [])


  const deleteData = async (del) => {
    try {
      const res = await axios.post("http://localhost:8080/deleteFeedBack", {
        id: del.id
      })
      alert(res.data)
    } catch (e) {
      console.log(e);
    }
    // console.log(message.cid);
  }
  return (
    <div className='m-5 p-10'>
      <div class="relative overflow-x-auto m-2 rounded-xl mb-5">
        <table class="w-full text-md rtl:text-right text-gray-500 dark:text-gray-400 text-center">
          <thead class="text-sm text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" class="px-6 py-3">
                Total Number of Admins
              </th>
              <th scope="col" class="px-6 py-3">
              Total Number of Students
              </th>
              <th scope="col" class="px-6 py-3">
              Total Number of Teachers
              </th>
              <th scope="col" class="px-6 py-3">
              Total Number of Users (ALL)
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 text-3xl">
              <td class="px-6 py-4">
                {count.admin}
              </td>
              <td class="px-6 py-4">
                {count.students}
              </td>
              <td class="px-6 py-4">
                {count.teachers}
              </td>
              <td class="px-6 py-4">
                {count.total}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="relative overflow-x-auto shadow-md sm:rounded-lg m-2">
        <table class="w-full text-md text-left rtl:text-right text-gray-500 dark:text-gray-400">
          <thead class="text-sm text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" class="px-6 py-3">
                Message no
              </th>
              <th scope="col" class="px-6 py-3">
                User name
              </th>
              <th scope="col" class="px-6 py-3">
                email
              </th>
              <th scope="col" colSpan={2} class="px-6 py-3">
                Message
              </th>
              <th scope="col" class="px-6 py-3">
                remove
              </th>
            </tr>
          </thead>
          <tbody>

            {
              contact.map((by) => (
                <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <td class="px-6 py-4">
                    {by.id}
                  </td>
                  <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                    {by.username}
                  </th>
                  <td class="px-6 py-4">
                    {by.email}
                  </td>
                  <td class="px-6 py-4 text-justify" colSpan={2}>
                    {by.message}
                  </td>
                  <td class="px-6 py-4">
                    <button class="font-medium text-red-600 dark:text-red-500 hover:underline" onClick={() => deleteData(by)}> Remove</button>
                  </td>
                </tr>
              ))
            }

          </tbody>
        </table>
      </div>
    </div>
  )
}
